// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ImageGallery = require("../../common/Components/ImageGallery.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardRelayPreviewImageGrid_displayHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewImageGrid_displayHelpers_graphql.bs.js");

let convertFragment = PropertyWizardRelayPreviewImageGrid_displayHelpers_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewImageGrid_displayHelpers_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewImageGrid_displayHelpers_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewImageGrid_displayHelpers_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewImageGrid_displayHelpers_graphql.node, convertFragment, fRef);
}

let DisplayHelpersFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Preview__ImageGrid(props) {
  let displayHelpers = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewImageGrid_displayHelpers_graphql.node, convertFragment, props.displayHelpers);
  let images = displayHelpers.images;
  let images$1 = images !== undefined ? images.map(img => img.fragmentRefs) : [];
  return JsxRuntime.jsx(ImageGallery.make, {
    images: images$1
  });
}

let MissingFieldMarker;

let Validators;

let make = PropertyWizardRelay__Preview__ImageGrid;

exports.MissingFieldMarker = MissingFieldMarker;
exports.Validators = Validators;
exports.DisplayHelpersFragment = DisplayHelpersFragment;
exports.make = make;
/* ImageGallery Not a pure module */
